import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import { toast } from 'react-toastify';
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitWhatsAppChatData } from "../../../../utils/whatsAppApi";
import '../../../../assets/css/app-whatsapp-chat-module.css';
import '../../../../assets/css/loader.css';

//Import Widgets
import DynamicTemplate from "../../../../components/Apps/WhatsAppChat/Template/DynamicTemplate";

//Import Tabs
import ConnectTab from "../../../../components/Apps/WhatsAppChat/ConnectTab";
import ContentTab from "../../../../components/Apps/WhatsAppChat/ContentTab";
import SettingTab from "../../../../components/Apps/WhatsAppChat/SettingTab";
import AppearanceTab from "../../../../components/Apps/WhatsAppChat/AppearanceTab";

export default function CreateWhatsAppChat() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Connect");
    const [activeTemplateSection, setActiveTemplateSection] = useState("General_Temp");
    const [selectedLayout, setSelectedLayout] = useState("general_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("general.png");
    const [whatsAppTabData, setWhatsAppTabData] = useState({
        is_website_frontend: "", 
        content_number: "",  
        content_bubble_icon: "",  
        content_bubble_text: "",  
        content_chat_window_picture: "",  
        content_chat_window_name: "John Doe",  
        content_chat_window_caption: "Online",  
        content_welcome_message: "Hi there How can I help you?",  
        content_start_chat_method: "Start_Chat_Button",  
        content_start_chat_button_text: "Chat on WhatsApp",  
        content_is_show_icon_in_button: 1,  
        content_whatsapp_pre_filled_message: "Hi", 
        content_whatsapp_message_field_placeholder: "Enter You Message...", 
        setting_position_type: "",  
        setting_position_alignment_type: "right-side",  
        setting_position_vertical_offset: "",  
        setting_position_horizonantal_offset: "",  
        setting_chat_display_pages_type: "All_Pages",  
        setting_chat_display_devices: ["Desktop", "Mobile Devices"],
        setting_chat_display_visitors_type: "All_Visitors",  
       setting_chat_display_date_time_display_chat_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],  
        setting_chat_display_date_time_is_time_schedule: 1,  
        setting_chat_display_date_time_start_time: "12:00 AM",  
        setting_chat_display_date_time_end_time: "1:00 AM",  
        setting_chat_display_date_time_time_zone: "",  
        setting_open_chat_triggers_is_on_page_load: 1,  
        setting_open_chat_triggers_time_on_page: "",  
        setting_open_chat_triggers_time_on_site: "",  
        setting_open_chat_triggers_scroll_position: "",  
        setting_open_chat_triggers_is_exit_intent: 1,  
        setting_open_chat_triggers_remembers_visitors: "1 Day",  
        setting_notifications_bubble_notification_badge: 0,  
        appearance_font_type: "",  
        appearance_bubble_background_color: "#000",  
        appearance_bubble_icon_color: "#000",  
        appearance_bubble_notification_badge_color: "#f00",  
        appearance_header_background_color: "#008069",  
        appearance_header_text_color: "#fff",  
        appearance_user_online_status_color: "#4ad504",  
        appearance_chat_wallpaper: "",  
        appearance_message_background_color: "#fff",  
        appearance_message_field_color: "#fff",  
        appearance_button_color: "#4afa6b",  
        appearance_enable_animation: "",  
        appearance_animation_interval: "",  
        appearance_custom_css:  "",  
        appearance_custom_js: "",  
    });
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled WhatsApp Chat");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let content_chat_window_picture = "";
        let appearance_bubble_background_color = "";
        let appearance_bubble_icon_color = "";
        let appearance_header_background_color = "";
        let appearance_header_text_color = "";
        let content_bubble_text = "";
    
        switch (activeTemplateSection) {
            case "General_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/general-pro.png`;
                appearance_bubble_background_color = "rgb(37, 211, 102)";
                appearance_bubble_icon_color = "#000";
                appearance_header_background_color = "#008069";
                appearance_header_text_color = "#fff";
                content_bubble_text = "";
                break;
            case "Message_Field_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/message-field-pro.png`;
                appearance_bubble_background_color = "rgb(37, 211, 102)";
                appearance_bubble_icon_color = "#000";
                appearance_header_background_color = "#008069"
                 appearance_header_text_color = "#fff"
                 content_bubble_text = "";
                break;
            case "White_Theme_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/white-theme-pro.png`;
                appearance_bubble_background_color = "rgb(37, 211, 102)";
                appearance_bubble_icon_color = "#000";
                appearance_header_background_color = "#fff"
                appearance_header_text_color = "#000"
                content_bubble_text = "";
                break;
            case "Light_Theme_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/light-theme-pro.png`;
                appearance_bubble_background_color = "rgb(37, 211, 102)";
                appearance_bubble_icon_color = "#000";
                appearance_header_background_color = "#fff"
                appearance_header_text_color = "#000"
                content_bubble_text = "";
                break;
            case "Dark_Theme_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/dark-theme-pro.png`;
                appearance_bubble_background_color = "#000";
                appearance_bubble_icon_color = "rgb(37, 211, 102)";
                appearance_header_background_color = "#152128"
                appearance_header_text_color = "#fff"
                content_bubble_text = "";
                break;
            case "Booking_Temp":
                content_chat_window_picture = `${process.env.PUBLIC_URL}/whats-app/templates/booking-pro.png`;
                appearance_bubble_background_color = "#003585";
                appearance_bubble_icon_color = "#fff";
                appearance_header_background_color = "#003585"
                appearance_header_text_color = "#fff"
                content_bubble_text = "Book a Room";
                break;
            default:
                content_chat_window_picture = "";
                appearance_bubble_background_color = "";
                appearance_header_background_color = "";
                appearance_bubble_icon_color = "";
                appearance_header_text_color = "";
                content_bubble_text = "";
        }
    
        // Update setWhatsAppTabData state with the data
        setWhatsAppTabData((prevData) => ({
            ...prevData,
            content_chat_window_picture: content_chat_window_picture,
            appearance_bubble_background_color: appearance_bubble_background_color,
            appearance_bubble_icon_color: appearance_bubble_icon_color,
            appearance_header_background_color: appearance_header_background_color,
            appearance_header_text_color: appearance_header_text_color,
            content_bubble_text: content_bubble_text,
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateWhatsAppTabData = (key, value) => {
        setWhatsAppTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }
    }; 

    const menuItems = [
        { key: "Connect", icon: "connect.png", label: "Connect" },
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
        { key: "Appearance", icon: "apperance.png", label: "Appearance" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Submit Form data
    const submitForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const formData = new FormData();

            // Append text fields
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", selectedTemplateImage);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
            formData.append("app_type", "Whats_App_Chat");
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(whatsAppTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if content_chat_window_picture is a File and append it
            if (whatsAppTabData.content_chat_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (whatsAppTabData.content_chat_window_picture instanceof File) {
                    formData.append("content_chat_window_picture", whatsAppTabData.content_chat_window_picture);
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof whatsAppTabData.content_chat_window_picture === 'string') {
                    const imageName = whatsAppTabData.content_chat_window_picture.split('/').pop();
                    formData.append("content_chat_window_picture", imageName);
                }
            }
         
            //Api Call
            let api_response = await submitWhatsAppChatData(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/whats-app-chat');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
          <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="WhatsApp Chat" app_type="Whats_App_Chat" app_slug="whats-app-chat"/>
                {showTemplateSelection ? (
                    <div className="create-goole-reviews-side">
                        <span>Select a template to start with</span>
                        <div className="card h-100">
                            <div className="label-box-flex">
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="General_Temp" data-layout_type="general_layout" data-template_image="general.png" checked={activeTemplateSection === "General_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className="card card-body">
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/general.png`} alt="general" />
                                        </div>
                                        <div className="content_sub">General</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Message_Field_Temp" data-layout_type="message_field_layout" data-template_image="message-field.png" checked={activeTemplateSection === "Message_Field_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/message-field.png`} alt="message-field" />
                                        </div>
                                        <div className="content_sub">Message Field</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="White_Theme_Temp" data-layout_type="white_theme_layout" data-template_image="white-theme.png" checked={activeTemplateSection === "White_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/white-theme.png`} alt="white-theme" />
                                        </div>
                                        <div className="content_sub">White Theme</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Light_Theme_Temp" data-layout_type="light_theme_layout" data-template_image="light-theme.png" checked={activeTemplateSection === "Light_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/light-theme.png`} alt="light-theme" />
                                        </div>
                                        <div className="content_sub">Light Theme</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Theme_Temp" data-layout_type="dark_theme_layout"  data-template_image="dark-theme.png" checked={activeTemplateSection === "Dark_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/dark-theme.png`} alt="dark-theme" />
                                        </div>
                                        <div className="content_sub">Dark Theme</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="app_template_type" className="card-input-element d-none" value="Booking_Temp" data-layout_type="booking_layout" data-template_image="booking.png" checked={activeTemplateSection === "Booking_Temp"} onChange={handleActiveTemplateInputChange} />
                                    <div className='card card-body'>
                                        <div className="content_head">
                                            <img src={`${process.env.PUBLIC_URL}/whats-app/templates/booking.png`} alt="booking" />
                                        </div>
                                        <div className="content_sub">Booking</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="continue-template">
                            <button onClick={handleContinueTemplate}>Continue with this template</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="overlay-side-baar">
                            <div className="side-baar-inner-one">
                                <ul>
                                    {menuItems.map((item) => (
                                        <li key={item.key}>
                                            <button
                                                className={activeSection === item.key ? "active" : ""}
                                                onClick={() => setActiveSection(item.key)}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/whats-app/icons//${item.icon}`}
                                                    alt={`${item.key} icon`}
                                                />
                                                <span>{item.label}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="side-baar-inner-tow">
                                {/* Conditional Rendering for Sections */}
                                {activeSection === "Connect" && (
                                  <ConnectTab updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                                )}
                                
                                {activeSection === "Content" && (
                                  <ContentTab updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                                )}

                                {activeSection === "Settings" && (
                                  <SettingTab updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                                )}

                                {activeSection === "Appearance" && (
                                  <AppearanceTab updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                                )}
                            </div>
                        </div>
                    </>
                )}
                <div className="create-goole-reviews-right">
                    <div className="content-wrapper">
                        <div className="source-header-row">
                            <h2><Link to="/customer/apps/whats-app-chat"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                            <div className="untitled-widget-name whtsapp-icon">
                                <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/whatsapp-white.svg`} alt="app-icon-4"/>{ widgetName }</button>
                                <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                            </div>
                            <div className='submit-google-review'>
                              <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                              <Link to="/customer/apps/whats-app-chat/pricing/single" className="view-plan">View Plans</Link>
                              <Link to="/customer/apps/whats-app-chat" className="close-button">Close</Link></div>
                        </div>
                        <div className="source-title-row">WhatsApp <img src={`${process.env.PUBLIC_URL}/images/icon-24.png`} alt="icon-24" /> <strong>Connect</strong></div>

                        {/*Check template type*/}
                        {activeTemplateSection === "General_Temp" && (
                            <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}

                        {activeTemplateSection === "Message_Field_Temp" && (
                            <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}

                        {activeTemplateSection === "White_Theme_Temp" && (
                          <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}

                        {activeTemplateSection === "Light_Theme_Temp" && (
                          <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}

                        {activeTemplateSection === "Dark_Theme_Temp" && (
                          <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}

                        {activeTemplateSection === "Booking_Temp" && (
                          <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}/>
                        )}
                    </div>
                </div>
            </div>

            {/* Rename Popup */}
            {renameWidgetNameModel && (
                <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                    <div className="bg-white p-3 rounded-lg shadow-lg">
                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                        <label>Widget Name</label>
                        <input
                            type="text"
                            className="border p-2 w-full mt-2"
                            value={newWidgetName}
                            onChange={(e) => setNewWidgetName(e.target.value)}
                        />
                        <div className="mt-3 flex justify-end">
                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                                Cancel
                            </button>
                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
      );
}
